import {useState} from "react";

const useFilters = (statuses: string[]): [
    Record<string, string[]>,
    (p: string, v: string[]) => void,
    () => void
  ] => {
    const [filters, setFilters] = useState<Record<string, string[]>>({
      status_name: statuses
    });
    const updateFilter = (property: string, values: string[]) => {
      setFilters({ ...filters, [property]: values });
    };
    const resetFilters = () => {
      setFilters({});
    }
  
    return [filters, updateFilter, resetFilters];
  };

  export default useFilters;